import { createRoot } from "react-dom/client";
import * as ReactDOM from "react-dom";
import WidgetWrapper from "./components/WidgetWrapper";

const currentScript = document.currentScript;

function initializeWidget() {
  if (document.readyState !== "loading") {
    onReady();
  } else {
    document.addEventListener("DOMContentLoaded", onReady);
  }
}

function onReady() {
  try {
    const element = document.createElement("div");
    const shadow = element.attachShadow({ mode: "open" });
    const shadowRoot = document.createElement("div");
    const attributeNames = {
      apiKey: "data-api-key",
      top: "data-top",
      left: "data-left",
      right: "data-right",
      bottom: "data-bottom",
    };

    const getAttribute = (name: string) => {
      return (
        document.currentScript?.getAttribute(name) ||
        currentScript?.getAttribute(name)
      );
    };

    const apiKey = getAttribute(attributeNames.apiKey);
    const top = getAttribute(attributeNames.top) || undefined;
    const left = getAttribute(attributeNames.left) || undefined;
    const right = getAttribute(attributeNames.right) || undefined;
    const bottom = getAttribute(attributeNames.bottom) || undefined;

    shadowRoot.id = "widget-root";
    console.log("Initializing widget", createRoot, ReactDOM, currentScript);
    const component = (
      <WidgetWrapper
        apiKey={apiKey || undefined}
        top={top}
        left={left}
        right={right}
        bottom={bottom}
      />
    );

    injectStyle(shadow);
    shadow.appendChild(shadowRoot);
    if (createRoot) {
      // React 18+
      console.log("Rendering React 18");
      createRoot(shadowRoot).render(component);
    } else {
      // React 17 and below
      try {
        console.log("Rendering React 17");
        ReactDOM.render(component, shadowRoot);
      } catch (error) {
        console.error("Failed to render React component:", error);
      }
    }

    document.body.appendChild(element);
  } catch (error) {
    console.warn("Widget initialization failed:", error);
  }
}

function injectStyle(shadowRoot: ShadowRoot) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = process.env.WIDGET_CSS_URL || "style.css";
  link.type = "text/css";
  shadowRoot.appendChild(link);

  // inject custom styles from index.css
  const styleTag = document.createElement("style");

  // defaul fallback fonts
  styleTag.innerHTML = `
      /* Sora font */
      @font-face {
        font-family: Sora;
        font-weight: 300;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Sora-Light.ttf");
      }
      @font-face {
        font-family: Sora;
        font-weight: 400;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Sora-Regular.ttf");
      }
      @font-face {
        font-family: Sora;
        font-weight: 500;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Sora-Medium.ttf");
      }
      @font-face {
        font-family: Sora;
        font-weight: 600;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Sora-SemiBold.ttf");
      }
      @font-face {
        font-family: Sora;
        font-weight: 700;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Sora-Bold.ttf");
      }
  
      /* Outfit font */
      @font-face {
        font-family: Outfit;
        font-weight: 300;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Outfit-Light.ttf");
      }
      @font-face {
        font-family: Outfit;
        font-weight: 400;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Outfit-Regular.ttf");
      }
      @font-face {
        font-family: Outfit;
        font-weight: 500;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Outfit-Medium.ttf");
      }
      @font-face {
        font-family: Outfit;
        font-weight: 600;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Outfit-SemiBold.ttf");
      }
      @font-face {
        font-family: Outfit;
        font-weight: 700;
        src: url("https://dev-julia-dashboard.globalstudy.technology/widget/src/assets/fonts/Outfit-Bold.ttf");
      }
    `;
  document.head.appendChild(styleTag);
}

initializeWidget();
